<template>
    <div class="lp-filter" role="listbox" :aria-label="Filters">
        <button type="button"
                v-for="(option, index) in options"
                class="lp-filter__item "
                :key="`filter-${index}`"
                :class="[option.ColorClass, { active: option.Selected }]"
                :style="[option.Selected ? 
                            {
                                'background-color': option.BackgroundColor,
                                'border-color': option.BackgroundColor
                            } : {
                                'background-color': 'transparent', 
                                'border-color': option.BackgroundColor
                            }
                        ]"
                v-on:click="optionClickedHandler(option)"
                role="option"
                :aria-selected="option.Selected">

        <img class="lp-filter__icon" v-if="option.ImageUrl" :src="option.ImageUrl" />
            {{ option.Title }}
        </button>
    </div>
</template>

<script lang="ts">
    import { pickTextColor } from '../helpers/textColor';
    import { defineComponent, watch } from "vue"

    export default defineComponent({
        name: 'TagFilter',
        methods: {
            optionClickedHandler: function (option) {
                this.$emit('option-clicked', option);
            }
        },
        props: {
            options: {
                type: Array,
                required: true,
            },
        },
        setup(props) {
            props.options.forEach((option: any) => {
                option["ColorClass"] = pickTextColor(option.BackgroundColor as string, "light-text", "dark-text");
            });
        },
    });
</script>

<style lang="scss" scoped></style>
